// Plan schemas (architecture.md §8.3 plans, §24 M10). Plans are DATA, editable in Super Admin.
import { z } from 'zod';

export const planSchema = z.object({
  name: z.string().trim().min(1).max(80),
  price_display: z.string().trim().min(1).max(40), // "₹0", "₹749", "Custom"
  billing_cycle: z.string().trim().max(40).optional().nullable(),
  badge_tag: z.string().trim().max(60).optional().nullable(),
  button_text: z.string().trim().max(60).optional().nullable(),
  display_order: z.number().int().min(0).default(0),
  description: z.string().trim().max(500).optional().nullable(),
  features_list: z.array(z.string().trim().min(1).max(200)).max(30).default([]),
  max_event_types: z.number().int().min(-1).default(1), // -1 = unlimited
  max_monthly_bookings: z.number().int().min(-1).default(-1), // bookings/month: -1 = unlimited
  max_employee_seats: z.number().int().min(-1).default(0), // team members: -1 = unlimited, 0 = none
  allow_custom_domains: z.boolean().default(false),
  allow_google_calendar_sync: z.boolean().default(false),
  allow_paid_bookings: z.boolean().default(false),
  allow_api_access: z.boolean().default(false),
  allow_mobile_app: z.boolean().default(false),
  allow_teams: z.boolean().default(false),
  allow_event_redirect: z.boolean().default(false), // per-event post-booking redirect (funnel)
  is_featured_dark: z.boolean().default(false),
  active: z.boolean().default(true), // deactivated plans are hidden from public pricing
});

export const updatePlanSchema = planSchema.partial();
